export default __webpack_public_path__ + "static/media/landing-1-dark.3326fd73.png";